
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11197",
                "data-name": "矩形 11197",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.277 0.064)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_238",
        "data-name": "蒙版组 238",
        "class": "cls-2",
        "transform": "translate(0.277 -0.064)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "Lifts",
            "transform": "translate(3.723 3.064)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7777",
                "data-name": "路径 7777",
                "class": "cls-3",
                "d": "M250.332,324.267a.53.53,0,0,1,.6.515V328.7l1.2-1.03a.645.645,0,0,1,.837,0,.452.452,0,0,1,0,.721l-2.273,1.854a.487.487,0,0,1-.359.1h-.239a.561.561,0,0,1-.359-.515v-5.15C249.733,324.473,249.973,324.267,250.332,324.267Zm-6.221.1a.487.487,0,0,1,.359-.1h.239c.359.1.479.309.479.515v5.15a.6.6,0,0,1-1.2,0v-4.017l-1.2,1.03a.645.645,0,0,1-.837,0,.452.452,0,0,1,0-.721Z",
                "transform": "translate(-239.46 -318.711)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7778",
                "data-name": "路径 7778",
                "class": "cls-3",
                "d": "M116.063,56.889h11.429a2.275,2.275,0,0,1,2.286,2.25v15.75h-16V59.139A2.275,2.275,0,0,1,116.063,56.889Zm12.571,2.25a1.071,1.071,0,0,0-1.143-1.125h-5.143v15.75h6.286ZM114.921,73.764h6.286V58.014h-5.143a1.071,1.071,0,0,0-1.143,1.125Z",
                "transform": "translate(-113.778 -56.889)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  